import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">© {currentYear} Sarah Parr Designs. All rights reserved.</p>
        <p className="credits">
          Made by <a href="https://granulardevelopment.com" target="_blank" rel="noopener noreferrer">Granular Development</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
